import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import SEO from "@/components/SEO";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <SEO />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
